import { getQueryParam } from '../../utils/UrlFormatters';
import { createImageStore } from '../lib';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../../application';

import ImageWizard from '../ImageWizard';

export default function NewImage({ endpoints }) {
  const filename = getQueryParam('filename') || '';
  const src = getQueryParam('img_src') || '';

  const image = {
    url: src,
    filename: filename,
    originalFilename: filename,
  };

  const imageStore = createImageStore(image, src ? 1 : null);

  return (
    <QueryClientProvider client={queryClient}>
      <ImageWizard {...{ imageStore, endpoints }} />
    </QueryClientProvider>
  );
}
